export default "__VITE_ASSET__Bp2d9q7I__"